import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 bg-[#F8FAFC]" data-id="element-167">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        <div className="max-w-3xl mx-auto" data-id="element-169">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center mb-12" data-id="element-170">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1E293B] mb-2" data-id="element-171">
              Why So Many Frenchies Have Tummy Trouble
            </h2>
            <p className="text-lg text-[#475569]" data-id="element-172">
              (And Why It's Usually Not The Food)
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-xl shadow-sm border border-[#E2E8F0] p-8 md:p-12" data-id="element-173">
            <div className="space-y-6 text-lg text-[#475569] leading-relaxed" data-id="element-174">
              <p data-id="element-175">Most Frenchie owners think the problem is the brand.</p>
              <p className="font-semibold text-[#1E293B]" data-id="element-176">So they switch.</p>
              <p className="font-semibold text-[#1E293B]" data-id="element-177">Then switch again.</p>
              <p data-id="element-178">
                But the real issue is usually{' '}
                <span className="font-semibold text-[#1E293B]" data-id="element-179">
                  inconsistency
                </span>{' '}
                — not the ingredients themselves.
              </p>
              <p data-id="element-180">
                And once things get off track, random changes tend to make it
                worse.
              </p>

              <div className="bg-[#F8FAFC] rounded-lg p-6 border-l-4 border-[#0F766E] my-8" data-id="element-181">
                <p className="italic text-[#475569] mb-4" data-id="element-182">Sound familiar?</p>
                <p className="italic text-[#1E293B]" data-id="element-183">
                  "Am I feeding too much?"
                </p>
                <p className="italic text-[#1E293B]" data-id="element-184">
                  "Should I try a different protein?"
                </p>
                <p className="italic text-[#1E293B]" data-id="element-185">
                  "Why does it get better… then go right back?"
                </p>
              </div>

              <p className="font-semibold text-[#1E293B]" data-id="element-186">You're not alone.</p>
              <p data-id="element-187">And it's not your fault.</p>
              <p className="text-[#0F766E] font-semibold text-xl" data-id="element-188">
                It's a structure problem — and it's fixable.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}